import apiClient from './client';
import type { Criteria } from '@business-game/shared';

/**
 * Criterias API Service
 *
 * Handles communication with criterias endpoints:
 * - Get criterias by language and session
 * - Get a single criteria by ID
 */

export const criteriasApi = {
  /**
   * Get criterias by language and optional session code
   * GET /api/criterias?lang=en&session=ABCD
   */
  async getCriterias(lang: string, sessionCode?: string): Promise<Criteria[]> {
    const params: Record<string, string> = { lang };
    if (sessionCode) {
      params.session = sessionCode;
    }

    const response = await apiClient.get('/criterias', { params });
    return response.data.data;
  },

  /**
   * Get a single criteria by ID
   * GET /api/criterias/:id
   */
  async getCriteriaById(id: number): Promise<Criteria> {
    const response = await apiClient.get(`/criterias/${id}`);
    return response.data.data;
  },
};

